/* ==========================================================================
   BV BASE - o que todo o tema usa
   Reune o que no prototipo morava em dados.js e mega.js, menos o que era
   catalogo em JSON: na loja quem entrega dado e o servidor.

   Aqui ficam:
     · BV.quandoPronto  - roda depois do DOM, com a mesma cara do prototipo;
     · BV.regua         - dica de "deslize" nas fileiras horizontais;
     · BV.dinheiro      - formato de moeda da loja, vindo do Liquid;
     · mega-menu        - abre/fecha os paineis que o servidor ja desenhou;
     · gaveta do menu   - abre/fecha;
     · segunda foto do cartao - some quando e quase igual a primeira;
     · voltar           - botao no topo das paginas internas.
   ========================================================================== */
window.BV = window.BV || {};

(function () {
  const dados = document.getElementById('bv-loja');
  BV.loja = dados ? JSON.parse(dados.textContent) : {};

  BV.quandoPronto = function (fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => fn(BV.loja));
    else fn(BV.loja);
  };

  /* ── Dica de rolagem horizontal (1.3.7: porte fiel de prototipo/js/dados.js) ──
     A versão anterior gerava outra marcação (dica__marca, dica__txt) que o
     CSS do tema não estiliza, e tratava `antes` como elemento - com `true`,
     quebrava. Esta é a do protótipo, que é a que o secoes.css desenha:
     trilho com polegar, "Desliza" com setas e um empurrão de 48px na
     primeira vez que a régua aparece. Some sozinha quando tudo cabe. */
  /* 1.4.8: rótulo pelo locale da página (antes, dicionário de 4 idiomas). */
  const DESLIZA = function () { return (BV.loja && BV.loja.textos && BV.loja.textos.desliza) || 'Desliza'; };
  BV.regua = function (el, semEspia, antes) {
    if (!el || el.dataset.bvRegua) return;
    el.dataset.bvRegua = '1';
    const dica = document.createElement('div');
    dica.className = 'dica';
    dica.setAttribute('aria-hidden', 'true');
    dica.innerHTML = '<span class="dica__trilho"><span class="dica__polegar"></span></span>' +
      '<span class="dica__rot">' + DESLIZA() + '<span class="dica__seta"><i></i><i></i><i></i></span></span>';
    el.insertAdjacentElement(antes ? 'beforebegin' : 'afterend', dica);
    const pol = dica.querySelector('.dica__polegar');
    /* Medidas em cache: durante o arrasto só a posição muda. */
    let total = 0, vis = 0, pedido = false, tocou = false;
    function dimensoes() {
      total = el.scrollWidth; vis = el.clientWidth;
      const rola = total - vis > 8;
      dica.hidden = !rola;
      if (rola) pol.style.setProperty('--w', Math.max(18, vis / total * 100) + '%');
      posicao();
    }
    function posicao() {
      pedido = false;
      if (dica.hidden) return;
      const w = Math.max(18, vis / total * 100);
      const x = Math.min(1, el.scrollLeft / (total - vis)) * (100 - w) / w * 100;
      pol.style.setProperty('--x', x + '%');
    }
    el.addEventListener('scroll', function () {
      if (tocou && el.scrollLeft > 4) dica.classList.add('usada');
      if (!pedido) { pedido = true; requestAnimationFrame(posicao); }
    }, { passive: true });
    function toque() { tocou = true; el.classList.remove('espia'); }
    el.addEventListener('touchstart', toque, { passive: true });
    el.addEventListener('pointerdown', toque, { passive: true });
    el.addEventListener('wheel', toque, { passive: true });
    window.addEventListener('resize', dimensoes, { passive: true });
    dimensoes();
    setTimeout(dimensoes, 600);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(dimensoes);
    if (!semEspia && 'IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      const io = new IntersectionObserver(function (ents) {
        if (!ents[0].isIntersecting) return;
        io.disconnect();
        if (dica.hidden || tocou) return;
        setTimeout(function () {
          if (tocou) return;
          el.classList.add('espia');
          setTimeout(function () { el.classList.remove('espia'); }, 1300);
        }, 300);
      }, { threshold: .6 });
      io.observe(el);
    }
  };

  /* Moeda: o formato vem da loja, nunca de conta feita aqui. */
  /* --- BV.seletor (1.3.8, porte de js/dados.js do protótipo) -------------
     Troca a lista nativa do <select> pelo seletor próprio da marca: botão
     "Ordenar por <valor>" e painel de opções (no celular, folha que sobe de
     baixo). O <select> continua no DOM, escondido, e recebe o `change`.
     1.5.4 (JM, 15/10/2026): "em todos os filtros tira esse design padrão do
     sistema" - a escolha de variante do produto (cor, tamanho...) também passa
     por aqui. opcoes.campo = botão de largura total no formato dos campos do
     formulário. Opção <option disabled> aparece apagada e não se escolhe.
     Teclado como na lista nativa: no botão, setas abrem; na lista, setas,
     Home/End e letras andam (pulando as apagadas), Enter/Espaço escolhem,
     Esc fecha e devolve o foco, Tab fecha. O <label for> do select passa a
     levar ao botão. Valores e textos entram escapados no HTML. */
  const escHtml = t => String(t).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const semAcento = t => String(t).toLowerCase().normalize('NFD').replace(/\p{M}/gu, '').trim();
  BV.seletor = function (sel, titulo, cfg) {
    if (!sel || sel._seletor) return;
    sel._seletor = true;
    cfg = cfg || {};
    const id = 'sel-' + Math.random().toString(36).slice(2, 8);
    const tit = escHtml(titulo || '');
    const caixa = document.createElement('div');
    caixa.className = 'seletor' + (cfg.campo ? ' seletor--campo' : '');
    caixa.innerHTML =
      '<button class="seletor__botao" id="' + id + '-b" type="button" aria-haspopup="listbox" aria-expanded="false" aria-controls="' + id + '">' +
        '<span class="seletor__rot">' + tit + '</span><strong></strong><span class="seletor__sinal" aria-hidden="true"></span></button>' +
      '<div class="seletor__camada" hidden><div class="seletor__fundo"></div>' +
        '<div class="seletor__painel" role="listbox" id="' + id + '" tabindex="-1" aria-label="' + tit + '">' +
          '<p class="seletor__titulo">' + tit + '</p>' +
          Array.from(sel.options).map(o => '<button type="button" role="option" data-v="' + escHtml(o.value) + '"' +
            (o.disabled ? ' aria-disabled="true"' : '') + '>' +
            '<span>' + escHtml(o.textContent) + '</span><i aria-hidden="true"></i></button>').join('') +
        '</div></div>';
    sel.insertAdjacentElement('afterend', caixa);
    sel.classList.add('sr'); sel.tabIndex = -1; sel.setAttribute('aria-hidden', 'true');
    const botao = caixa.querySelector('.seletor__botao');
    const camada = caixa.querySelector('.seletor__camada');
    const opcoes = Array.from(caixa.querySelectorAll('[role="option"]'));
    const livre = b => b.getAttribute('aria-disabled') !== 'true';
    const rotulo = sel.id && document.querySelector('label[for="' + sel.id + '"]');
    if (rotulo) rotulo.addEventListener('click', function (ev) { ev.preventDefault(); botao.focus(); });
    function pinta() {
      const o = sel.options[sel.selectedIndex];
      botao.querySelector('strong').textContent = o ? o.textContent : '';
      opcoes.forEach(b => b.setAttribute('aria-selected', String(b.dataset.v === sel.value)));
    }
    let t = null;
    function abre(ultima) {
      clearTimeout(t);
      camada.hidden = false; void camada.offsetHeight;
      caixa.classList.add('aberto'); botao.setAttribute('aria-expanded', 'true');
      const vale = opcoes.filter(livre);
      const alvo = ultima ? vale[vale.length - 1] : (opcoes.find(b => b.getAttribute('aria-selected') === 'true') || vale[0]);
      (alvo || opcoes[0]).focus({ preventScroll: true });
    }
    function fecha(foco) {
      if (camada.hidden) return;
      caixa.classList.remove('aberto'); botao.setAttribute('aria-expanded', 'false');
      t = setTimeout(() => { camada.hidden = true; }, 280);
      if (foco) botao.focus({ preventScroll: true });
    }
    /* Anda a partir da posição k no sentido do passo, pulando as apagadas. */
    function vai(k, passo) {
      const n = opcoes.length;
      for (let i = 1; i <= n; i++) {
        const b = opcoes[((k + passo * i) % n + n) % n];
        if (livre(b)) { b.focus(); return; }
      }
    }
    let digitado = '', tempoLetra = null;
    function letra(ch, k) {
      digitado += semAcento(ch);
      clearTimeout(tempoLetra); tempoLetra = setTimeout(() => { digitado = ''; }, 700);
      const n = opcoes.length, inicio = digitado.length > 1 ? k - 1 : k;
      for (let i = 1; i <= n; i++) {
        const b = opcoes[(inicio + i + n) % n];
        if (livre(b) && semAcento(b.textContent).startsWith(digitado)) { b.focus(); return; }
      }
    }
    botao.addEventListener('click', () => (camada.hidden ? abre() : fecha()));
    botao.addEventListener('keydown', function (ev) {
      if (ev.key === 'ArrowDown' || ev.key === 'ArrowUp') { ev.preventDefault(); abre(ev.key === 'ArrowUp'); }
    });
    caixa.querySelector('.seletor__fundo').addEventListener('click', () => fecha(true));
    opcoes.forEach(function (b, k) {
      b.addEventListener('click', function () {
        if (!livre(b)) return;
        if (sel.value !== b.dataset.v) { sel.value = b.dataset.v; sel.dispatchEvent(new Event('change', { bubbles: true })); }
        pinta(); fecha(true);
      });
      b.addEventListener('keydown', function (ev) {
        if (ev.key === 'ArrowDown') { ev.preventDefault(); vai(k, 1); }
        else if (ev.key === 'ArrowUp') { ev.preventDefault(); vai(k, -1); }
        else if (ev.key === 'Home') { ev.preventDefault(); vai(-1, 1); }
        else if (ev.key === 'End') { ev.preventDefault(); vai(opcoes.length, -1); }
        else if (ev.key === 'Escape') { ev.preventDefault(); fecha(true); }
        else if (ev.key === 'Tab') fecha(false);
        else if (ev.key.length === 1 && ev.key !== ' ' && !ev.ctrlKey && !ev.metaKey && !ev.altKey) { ev.preventDefault(); letra(ev.key, k); }
      });
    });
    document.addEventListener('click', ev => { if (!caixa.contains(ev.target)) fecha(); });
    sel.addEventListener('change', pinta);
    pinta();
  };

  /* 1.4.7 (JM, 05/10/2026): no celular o painel do seletor é uma folha que
     sobe de baixo (país da home, "Envío a", ordenação). Arrastar a folha para
     baixo - pela barrinha/título ou pela lista já no topo - fecha, como nos
     menus do iPhone. Fechar = o mesmo toque no fundo escuro que cada seletor
     já escuta, então serve para todos sem mexer em cada um. */
  (function () {
    const celular = window.matchMedia('(max-width: 767px)');
    let painel = null, y0 = 0, dy = 0, t0 = 0, arrasta = false;
    document.addEventListener('touchstart', function (ev) {
      if (!celular.matches || ev.touches.length !== 1) return;
      const p = ev.target.closest && ev.target.closest('.seletor.aberto .seletor__painel');
      if (!p) return;
      const noTopo = ev.touches[0].clientY - p.getBoundingClientRect().top < 72;
      if (!noTopo && p.scrollTop > 0) return;
      painel = p; y0 = ev.touches[0].clientY; dy = 0; t0 = Date.now(); arrasta = false;
    }, { passive: true });
    document.addEventListener('touchmove', function (ev) {
      if (!painel) return;
      dy = ev.touches[0].clientY - y0;
      if (!arrasta) {
        if (dy < 0) { painel = null; return; }
        if (dy < 6) return;
        arrasta = true; painel.style.transition = 'none';
      }
      painel.style.transform = 'translateY(' + Math.max(0, dy) + 'px)';
      if (ev.cancelable) ev.preventDefault();
    }, { passive: false });
    function solta() {
      if (!painel) return;
      const p = painel; painel = null;
      if (!arrasta) return;
      p.style.transition = '';
      const rapido = dy / Math.max(1, Date.now() - t0) > 0.5;
      if (dy > 90 || (rapido && dy > 30)) {
        p.style.transform = 'translateY(100%)';
        const fundo = p.closest('.seletor').querySelector('.seletor__fundo');
        if (fundo) fundo.click();
        setTimeout(function () { p.style.transform = ''; }, 400);
      } else {
        p.style.transform = '';
      }
    }
    document.addEventListener('touchend', solta);
    document.addEventListener('touchcancel', solta);
  })();

  /* 1.3.9: "Envío a" (produto e coleção) usa o mesmo seletor da marca; o
     <select> escondido segue enviando o formulário de localização. */
  BV.quandoPronto(function () {
    document.querySelectorAll('.envio__sel').forEach(function (s) {
      BV.seletor(s, s.dataset.titulo || '');
      const f = s.closest('.envio'); if (f) f.classList.add('envio--js');
    });
  });

  BV.dinheiro = function (centavos) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'es-ES',
        { style: 'currency', currency: BV.loja.moeda || 'EUR' }).format(centavos / 100);
    } catch (e) { return (centavos / 100).toFixed(2); }
  };
})();

/* ── MEGA-MENU ─────────────────────────────────────────────────────────────
   Abre por CLIQUE sempre, e por hover COM INTENCAO onde existe ponteiro fino:
   hover cru abre menu de raspao no caminho para o carrinho. */
BV.quandoPronto(function () {
  const linha = document.getElementById('nav-linha');
  const mega = document.getElementById('mega');
  const cab = document.getElementById('cab');
  if (!linha || !mega || !cab) return;
  const paineis = Array.from(mega.querySelectorAll('[data-painel]'));
  const botoes = Array.from(linha.querySelectorAll('.nav__item'));
  const podeHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  const ABRIR = 110, FECHAR = 220;
  let aberta = null, tAbrir = null, tFechar = null;

  function fecha() {
    mega.classList.remove('aberto');
    mega.hidden = true;
    cab.classList.remove('aberto');
    botoes.forEach(b => b.setAttribute('aria-expanded', 'false'));
    aberta = null;
  }
  function abre(chave, botao) {
    aberta = chave;
    botoes.forEach(b => b.setAttribute('aria-expanded', String(b === botao)));
    paineis.forEach(p => { p.hidden = p.dataset.painel !== chave; });
    mega.hidden = false;
    cab.classList.add('aberto');
    /* Reflow forcado em vez de requestAnimationFrame: o rAF nao dispara em
       aba de segundo plano, e isso ja custou uma vitrine vazia neste projeto. */
    void mega.offsetHeight;
    mega.classList.add('aberto');
  }
  function cancela() { clearTimeout(tAbrir); clearTimeout(tFechar); }

  linha.addEventListener('click', function (ev) {
    const b = ev.target.closest('[data-cat]');
    if (!b) return;
    cancela();
    if (aberta === b.dataset.cat) return fecha();
    abre(b.dataset.cat, b);
  });

  if (podeHover) {
    linha.addEventListener('mouseover', function (ev) {
      const b = ev.target.closest('[data-cat]');
      if (!b) return;
      cancela();
      tAbrir = setTimeout(() => abre(b.dataset.cat, b), ABRIR);
    });
    [linha, mega].forEach(function (el) {
      el.addEventListener('mouseleave', function () { cancela(); tFechar = setTimeout(fecha, FECHAR); });
      el.addEventListener('mouseenter', cancela);
    });
  }
  document.addEventListener('keydown', ev => { if (ev.key === 'Escape' && !mega.hidden) fecha(); });
  document.addEventListener('click', function (ev) {
    if (!mega.hidden && !ev.target.closest('#mega') && !ev.target.closest('#nav-linha')) fecha();
  });
});

/* ── GAVETA DO MENU (celular e tablet) ─────────────────────────────────── */
BV.quandoPronto(function () {
  const gaveta = document.getElementById('menu-movel');
  const btn = document.getElementById('btn-menu');
  if (!gaveta || !btn) return;
  let voltar = null;

  function abre() {
    voltar = document.activeElement;
    gaveta.hidden = false;
    void gaveta.offsetHeight;
    gaveta.classList.add('aberta');
    btn.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('sem-rolagem');
    const fechar = gaveta.querySelector('.gaveta__fechar');
    if (fechar) fechar.focus({ preventScroll: true });
  }
  function fecha() {
    gaveta.classList.remove('aberta');
    btn.setAttribute('aria-expanded', 'false');
    document.documentElement.classList.remove('sem-rolagem');
    setTimeout(() => { gaveta.hidden = true; }, 260);
    if (voltar) voltar.focus({ preventScroll: true });
  }
  btn.addEventListener('click', () => (gaveta.hidden ? abre() : fecha()));
  gaveta.addEventListener('click', ev => { if (ev.target.closest('[data-fecha-menu]')) fecha(); });
  document.addEventListener('keydown', ev => { if (ev.key === 'Escape' && !gaveta.hidden) fecha(); });

  const lupa = document.getElementById('gaveta-busca');
  if (lupa) lupa.addEventListener('click', function () {
    fecha();
    const b = document.getElementById('btn-busca');
    if (b) b.click();
  });
});

/* ── SEGUNDA FOTO DO CARTAO ────────────────────────────────────────────────
   Quando as duas fotos do produto sao quase a mesma imagem, a troca no hover
   le como um piscar sem sentido e o zoom some debaixo dela. Aqui as duas sao
   comparadas de verdade (24x24, diferenca media por canal) e, abaixo do
   limite, a segunda sai do cartao: fica so o zoom, que e o que um bom
   e-commerce faz quando nao ha um segundo angulo para mostrar.
   Limite MEDIDO em 40 produtos da loja: abaixo de 26 estao os pares que sao a
   mesma foto de novo; acima comecam as fotos que mostram outra coisa. */
(function fotoDupla() {
  const LIMITE = 26, LADO = 24, MAX = 3;
  const memoria = new Map();
  const fila = [];
  let ativos = 0, agendado = false;

  function ocioso(fn) {
    let feito = false;
    const uma = function () { if (feito) return; feito = true; fn(); };
    if (window.requestIdleCallback) window.requestIdleCallback(uma, { timeout: 500 });
    setTimeout(uma, 400);
  }
  function comPrazo(p, ms) {
    return new Promise(function (ok, erro) {
      const t = setTimeout(() => erro(new Error('prazo')), ms);
      p.then(v => { clearTimeout(t); ok(v); }, e => { clearTimeout(t); erro(e); });
    });
  }
  function miniatura(url) {
    return new Promise(function (ok, erro) {
      const im = new Image();
      im.crossOrigin = 'anonymous';
      im.onload = function () {
        const c = document.createElement('canvas');
        c.width = c.height = LADO;
        const ctx = c.getContext('2d', { willReadFrequently: true });
        ctx.drawImage(im, 0, 0, LADO, LADO);
        try { ok(ctx.getImageData(0, 0, LADO, LADO).data); } catch (e) { erro(e); }
      };
      im.onerror = erro;
      im.src = url.split('?')[0] + '?width=64';
    });
  }
  function diferenca(a, b) {
    let s = 0;
    for (let i = 0; i < a.length; i += 4) s += Math.abs(a[i] - b[i]) + Math.abs(a[i + 1] - b[i + 1]) + Math.abs(a[i + 2] - b[i + 2]);
    return s / (a.length / 4 * 3);
  }
  function trata(card) {
    const um = card.querySelector('.card__foto--1');
    const dois = card.querySelector('.card__foto--2');
    if (!um || !dois) return Promise.resolve();
    const chave = um.src + '|' + dois.src;
    if (memoria.has(chave)) {
      if (memoria.get(chave)) { dois.remove(); card.dataset.bvFoto = 'zoom'; }
      else card.dataset.bvFoto = 'troca';
      return Promise.resolve();
    }
    return comPrazo(Promise.all([miniatura(um.src), miniatura(dois.src)]), 4000).then(function (p) {
      const igual = diferenca(p[0], p[1]) < LIMITE;
      memoria.set(chave, igual);
      if (igual) { dois.remove(); card.dataset.bvFoto = 'zoom'; }
      else card.dataset.bvFoto = 'troca';
    }).catch(function () { card.dataset.bvFoto = 'troca'; });
  }
  function bombeia() {
    while (ativos < MAX && fila.length) {
      const card = fila.shift();
      if (!card.isConnected || card.dataset.bvFoto) continue;
      ativos++;
      trata(card).then(() => { ativos--; bombeia(); }, () => { ativos--; bombeia(); });
    }
  }
  function anda() {
    if (agendado) return;
    agendado = true;
    ocioso(function () { agendado = false; bombeia(); });
  }
  function entra(card) {
    if (!card || card.dataset.bvFoto || fila.indexOf(card) >= 0) return;
    if (!card.querySelector('.card__foto--2')) return;
    fila.push(card);
    anda();
  }
  function varre(raiz) {
    if (!raiz.querySelectorAll) return;
    if (raiz.matches && raiz.matches('.card')) entra(raiz);
    raiz.querySelectorAll('.card').forEach(entra);
  }
  function iniciar() {
    varre(document.body);
    new MutationObserver(l => l.forEach(m => m.addedNodes.forEach(varre)))
      .observe(document.body, { childList: true, subtree: true });
  }
  if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    if (document.body) iniciar(); else document.addEventListener('DOMContentLoaded', iniciar);
  }
})();

/* ── PRODUTOS RECOMENDADOS ─────────────────────────────────────────────────
   A Shopify entrega as recomendacoes numa chamada propria: a pagina de
   produto nao espera por elas para desenhar. */
BV.quandoPronto(function () {
  const alvo = document.querySelector('[data-recomendados]');
  if (!alvo || !alvo.dataset.url || alvo.children.length) return;
  fetch(alvo.dataset.url)
    .then(r => r.text())
    .then(function (html) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const grade = doc.querySelector('[data-recomendados]');
      if (grade) alvo.innerHTML = grade.innerHTML;
    })
    .catch(function () { /* sem recomendacao a secao so fica vazia */ });
});

/* ── PAÍS DO FORMULÁRIO COD (1.5.2, 12/10/2026; 1.5.3 em 13/10) ──────────────────────────────
   O Releasit tem um seletor de país (antes todo pedido COD saía como Espanha).
   Ele vem preenchido pelo IP e aceitaria qualquer país da lista, mas cada
   produto tem os SEUS países de COD - e o tema só mostra o botão quando o país
   do "Envío a" está na etiqueta cod-xx do produto (ou de todos os itens da
   sacola). Por isso o seletor começa no país do "Envío a" (a resposta do IP
   chega depois e reescreve: a conferência repete). Se a PESSOA trocar o país
   ali, a loja muda de mercado e recarrega a mesma página, e o tema volta a
   conferir: com COD lá, o botão reaparece já no país novo; sem COD, só cartão. */
(function () {
  const pais = String((window.Shopify && Shopify.country) || '').toUpperCase();
  if (!pais) return;
  const SEL = 'select[name^="additionals_country_selector"]';
  const definir = Object.getOwnPropertyDescriptor(HTMLSelectElement.prototype, 'value').set;
  let trocando = false;

  function trocarPais(iso) {
    const form = document.querySelector('form[action*="/localization"]');
    if (!form) return false;
    const campo = function (nome) {
      let el = form.querySelector('input[name="' + nome + '"]');
      if (!el) { el = document.createElement('input'); el.type = 'hidden'; el.name = nome; form.appendChild(el); }
      return el;
    };
    const lingua = document.querySelector('[name="country_code"] option[value="' + iso + '"], button[name="country_code"][value="' + iso + '"]');
    campo('country_code').value = iso;
    if (lingua && lingua.dataset.lingua) campo('language_code').value = lingua.dataset.lingua;
    form.querySelectorAll('button[name="country_code"]').forEach(b => b.disabled = true);
    trocando = true;
    form.submit();
    return true;
  }

  document.addEventListener('change', function (e) {
    const sel = e.target;
    if (!e.isTrusted || !sel.matches || !sel.matches(SEL)) return;
    if (sel.value && sel.value !== pais && !trocarPais(sel.value)) {
      definir.call(sel, pais);
      sel.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }, true);

  /* 1.5.3: em PT e RO o rótulo da província vem do campo do país dentro do
     Releasit, que só tem inglês ("Province") e ignora a tradução do app. */
  const PROVINCIA = { PT: ['Distrito', 'Escolhe o teu distrito'], RO: ['Județ', 'Selectează județul'] }[pais];
  function nomearProvincia() {
    const campo = document.querySelector('select[name="province_country_field"]');
    if (!campo) return;
    const rotulo = document.querySelector('label[for="province_country_field"]');
    const texto = rotulo && [].find.call(rotulo.childNodes, n => n.nodeType === 3);
    if (texto && texto.nodeValue !== PROVINCIA[0]) texto.nodeValue = PROVINCIA[0];
    const vazia = campo.querySelector('option[value=""]');
    if (vazia && vazia.textContent !== PROVINCIA[1]) vazia.textContent = PROVINCIA[1];
  }

  setInterval(function () {
    if (PROVINCIA) nomearProvincia();
    if (trocando) return;
    document.querySelectorAll(SEL).forEach(function (sel) {
      if (sel.value === pais || ![].some.call(sel.options, o => o.value === pais)) return;
      definir.call(sel, pais);
      sel.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }, 400);
})();
